import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Title from '../../../layout/Title/Title';
import "./productoPage.css";

function useMediaQuery(query) {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);
    if (media.matches !== matches) {
      setMatches(media.matches);
    }
    const listener = () => setMatches(media.matches);
    media.addEventListener("change", listener);
    return () => media.removeEventListener("change", listener);
  }, [matches, query]);

  return matches;
}

const ProductoPage = ({ data }) => {
  const { categorySlug, productSlug } = useParams();
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width: 768px)");
  const strapiBase = process.env.REACT_APP_STRAPI_API_BASE.replace("/api", "");

  const [category, setCategory] = useState(null);
  const [product, setProduct] = useState(null);

  useEffect(() => {
    if (data.length > 0) {
      const foundCategory = data.find(cat => cat.slug === categorySlug);
      if (!foundCategory) {
        navigate("/404");
        return;
      }

      const foundProduct = foundCategory.products.find(prod => prod.slug === productSlug);
      if (!foundProduct) {
        navigate("/404");
        return;
      }

      setCategory(foundCategory);
      setProduct(foundProduct);
    }
  }, [data, categorySlug, productSlug, navigate]);

  if (!category || !product) return null;

  const image = product.images?.[0];
  const backgroundImageUrl = isMobile
    ? `${strapiBase}${image?.urlMobile || "/assets/imgs/default-product.jpg"}`
    : `${strapiBase}${image?.urlDesktop || "/assets/imgs/default-product.jpg"}`;

  const productTitle = image?.title || "Sin título";

  return (
    <>
      <Title text={productTitle} />
      <div className="container product-detail">
        <div
          className="product-image-container"
          style={{ backgroundImage: `url(${backgroundImageUrl})` }}
        ></div>
        <div className="container-btn-cotizanos">
          <a className="cotizanos" href="#footer-quality-seal">SOLICITA UNA COTIZACIÓN</a>
        </div>
      </div>
    </>
  );
};

export default ProductoPage;
